import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventResultPipe'
})
export class EventResultPipe implements PipeTransform {
  transform(items: any[], eventId: string): any {
    if (!items || !eventId) {
      return items;
    }

    return items.filter(
      item =>
        item.eventTypeId.toString() === eventId
    );
  }
}